import React from "react";
import "../../../providers/profile/style.css";
import Details from "./Components/RequestData/index";
import ProviderDetailsSkeleton from "./Components/ProviderDetailsSkeleton";
import { CRRender } from "@/components/crRender";

const ProfileData = ({ requestDetails, isPending }) => {
    return (
        <>
            <ProviderDetailsSkeleton isRender={!!isPending} />
            <CRRender isRender={!isPending}>
                <Details requestDetails={requestDetails} />
            </CRRender>
        </>
    );
}

export default ProfileData